<template>
    <section class="sms-broadcast-footer">
        <hr />

        <span>Text messaging has many rules and regulations. Make sure you understand them.</span>

        <div class="sms-broadcast-footer-links">
            <a
                :title="tcpaLawsLink"
                :href="tcpaLawsLink"
                class="rules-and-regulations-link"
                rel="noopener noreferer"
                target="_blank"
            >
                Read the TCPA laws
                <ds-icon name="external-link" />
            </a>

            <a
                :title="bestPracticesLink"
                :href="bestPracticesLink"
                class="rules-and-regulations-link"
                rel="noopener noreferer"
                target="_blank"
            >
                Review best practices
                <ds-icon name="external-link" />
            </a>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            tcpaLawsLink: 'https://www.fdic.gov/regulations/compliance/manual/8/viii-5.1.pdf',
            bestPracticesLink: 'https://www.twilio.com/learn/call-and-text-marketing/guide-to-us-sms-compliance',
        };
    },
};
</script>

<style lang="scss" scoped>
    .sms-broadcast-footer {
        padding-bottom: $spacing-200;
        font-size: $font-size-xs;
        gap: $spacing-100;
        color: $color-gray-700;
        background-color: $color-white;
        display: flex;
        flex-direction: column;
    }

    hr {
        margin: 0 0 $spacing-100;
    }

    .sms-broadcast-footer-links {
        display: flex;
        align-items: center;
        gap: $spacing-500;
        text-decoration: underline;

        .rules-and-regulations-link {
            display: flex;
            flex-direction: row;
            gap: $spacing-050;
            --icon-size: #{px-to-rem(13.33px)};
            color: $color-gray-700;
        }
    }
</style>
